import {
  Box,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";

const TentativeBurdenMix = ({ data }) => {
  // console.log(data);

  const formatValue = (val) => {
    if (val == undefined) {
      return "";
    }
    if (isNaN(val) == false) {
      return val.toFixed(3);
    }
    return val;
  };

  const getValue = (name) => {
    return formatValue(data?.[name]);
  };

  function calculateTotal(obj) {
    const values = Object.values(obj);
    const sum = values.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
    return sum.toFixed(3);
  }

  // const getTolerence = (name) => {
  //   return formatValue(
  //     controllers.find((el) => el.name == name + "_TOLERANCE")?.value
  //   );
  // };

  // const countTotal = Object.keys(data)?.map((ele) => parseFloat(getValue(ele)));

  // // Calculate the total sum
  // const totalSum = countTotal.reduce(
  //   (sum, value) => sum + (isNaN(value) ? 0 : value),
  //   0
  // );

  return (
    <Box>
      <TableContainer overflowY="auto" mt="1rem" w="100%">
        <Table size="sm">
          <Thead bg="gray.200" position="sticky" top="0" zIndex="sticky">
            <Tr>
              <Th
                whiteSpace="pre-line"
                wordWrap="break-word"
                // border="1px solid gray"
                maxW="100px"
                key={Math.random()}
                textAlign="center"
                fontSize="xs"
                textTransform="none"
              >
                Name
              </Th>
              <Th
                whiteSpace="pre-line"
                wordWrap="break-word"
                // border="1px solid gray"
                maxW="100px"
                key={Math.random()}
                textAlign="center"
                fontSize="xs"
                textTransform="none"
              >
                Value
              </Th>
              {/* <Th
                whiteSpace="pre-line"
                wordWrap="break-word"
                // border="1px solid gray"
                maxW="100px"
                key={Math.random()}
                textAlign="center"
                fontSize="xs"
                textTransform="none"
              >
                Tolerence
              </Th> */}
            </Tr>
          </Thead>
          <Tbody>
            {Object.keys(data)
              ?.sort()
              ?.map((name, rowIndex) => (
                <Tr key={rowIndex}>
                  <Td border="1px solid #e2e8f0" maxW="100px" p="0" m="0">
                    <Box
                      border="none"
                      type="text"
                      outline="none"
                      textAlign="left"
                      fontSize="xs"
                      w="100%"
                      h="100%"
                      p="4px"
                      pl="10%"
                      borderRadius={0}
                      whiteSpace="pre-line"
                      wordWrap="break-word"
                    >
                      {name}
                    </Box>
                  </Td>
                  <Td border="1px solid #e2e8f0" maxW="100px" p="0" m="0">
                    <Box
                      border="none"
                      type="text"
                      outline="none"
                      textAlign="center"
                      fontSize="xs"
                      w="100%"
                      h="100%"
                      p="4px"
                      borderRadius={0}
                      whiteSpace="pre-line"
                      wordWrap="break-word"
                    >
                      {getValue(name)}
                    </Box>
                  </Td>
                  {/* <Td border="1px solid #e2e8f0" maxW="100px" p="0" m="0">
                  <Box
                    border="none"
                    type="text"
                    outline="none"
                    textAlign="center"
                    fontSize="xs"
                    w="100%"
                    h="100%"
                    p="4px"
                    borderRadius={0}
                    whiteSpace="pre-line"
                    wordWrap="break-word"
                  >
                    {getTolerence(name)}
                  </Box>
                </Td> */}
                </Tr>
              ))}
            <Tr>
              <Td border="1px solid #e2e8f0" maxW="100px" p="0" m="0">
                <Box
                  border="none"
                  type="text"
                  outline="none"
                  textAlign="left"
                  fontSize="xs"
                  w="100%"
                  h="100%"
                  p="4px"
                  pl="10%"
                  borderRadius={0}
                  whiteSpace="pre-line"
                  wordWrap="break-word"
                  fontWeight="700"
                >
                  Total
                </Box>
              </Td>
              <Td border="1px solid #e2e8f0" maxW="100px" p="0" m="0">
                <Box
                  border="none"
                  type="text"
                  outline="none"
                  textAlign="center"
                  fontSize="xs"
                  w="100%"
                  h="100%"
                  p="4px"
                  borderRadius={0}
                  whiteSpace="pre-line"
                  wordWrap="break-word"
                  fontWeight="700"
                >
                  {calculateTotal(data)}
                </Box>
              </Td>
              {/* <Td border="1px solid #e2e8f0" maxW="100px" p="0" m="0">
                <Box
                  border="none"
                  type="text"
                  outline="none"
                  textAlign="center"
                  fontSize="xs"
                  w="100%"
                  h="100%"
                  p="4px"
                  borderRadius={0}
                  whiteSpace="pre-line"
                  wordWrap="break-word"
                ></Box>
              </Td> */}
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TentativeBurdenMix;
